<template>
    <div class="w-full px-6 py-8">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div v-for="(card, index) in infoCards" :key="index"
                :class="[
                    'bg-gradient-to-t from-blue-900 via-blue-500 to-blue-900 rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:transform hover:scale-105 flex mb-4',
                    { 'flex-col h-full': isViajeFamiliar },  // Aplicamos un alto fijo solo para ViajeFamiliar
                    { 'h-auto': !isViajeFamiliar }  // Mantenemos el alto automático para los demás componentes
                ]">
                
                <!-- Imagen -->
                <div v-if="!isViajeFamiliar" class="w-2/5 bg-blue-600">
                    <img :src="card.image" :alt="card.title" class="w-full h-full object-cover">
                </div>
                <div v-if="isViajeFamiliar" class="w-full h-80">
                    <img :src="card.image" :alt="card.title" class="w-full h-full object-cover">
                </div>

                <!-- Contenido de la tarjeta -->
                <div v-if="!isViajeFamiliar" class="w-3/4 p-4">
                    <h2 class="text-xl font-bold text-white mb-2">{{ card.title }}</h2>
                    <p class="text-white text-justify" v-html="card.content"></p>
                </div>
                <div v-if="isViajeFamiliar" class="px-5 pt-3 overflow-hidden"> <!-- Limitar la altura -->
                    <h2 class="text-xl font-bold text-white mb-2">{{ card.title }}</h2>
                    <p class="text-white text-justify max-h-32 overflow-y-auto pr-2" v-html="card.content"></p> <!-- Limita la altura del contenido y agrega scroll si es necesario -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        infoCards: {
            type: Array,
            required: true
        },
        isViajeFamiliar: {
            type: Boolean,
            default: false
        }
    }
}
</script>